import React from 'react';
import { ReactTabulator } from 'react-tabulator';
import 'react-tabulator/lib/styles.css'; // required styles
import 'react-tabulator/lib/css/semantic-ui/tabulator_semantic-ui.min.css';

interface ProjectLinesTableProps {
  data: any;
  numberOfApplications: number;
  onCellEdited: any;
  onDataChanged: any;
  resort: any;
  rightClickMenu: any;
  parseClipboard: any;
}

export default class ProjectLinesTable extends React.Component<ProjectLinesTableProps> {
  ref?: React.ElementRef<any>;

  constructor(props: ProjectLinesTableProps) {
    super(props);
  }

  shouldComponentUpdate(nextProps: any) {
    const currentData = this.props.data;    
    const nextData = nextProps.data;
    return currentData.rows.length !== nextData.rows.length;
  }

  render(): React.ReactNode {
    const { data, numberOfApplications, onCellEdited, onDataChanged, resort, rightClickMenu, parseClipboard } = this.props;
    const disableEditing = (numberOfApplications ?? 0) > 1;
    const columns = (data.columns || []).map((col: any) => ({
      ...col,
      editor: disableEditing ? false : col.editor,
      editable: disableEditing ? false : col.editable,
    }));    return (
      <div style={disableEditing ? { cursor: 'default' } : undefined} className={disableEditing ? 'view-only-table' : undefined}>
        <style>{disableEditing ? `.view-only-table .tabulator-row, .view-only-table .tabulator-cell { cursor: default !important; }` : ''}</style>
        <ReactTabulator
          ref={(ref: any) => (this.ref = ref)}
          data={data.rows}
          columns={columns}
          clipboard={!disableEditing}
          clipboardPasteAction='insert'
          cellEdited={(cell: any): any => onCellEdited(cell)}
          dataChanged={(data: any): any => onDataChanged(data)}
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          clipboardPasteParser={(clipboard): Array<RowData> => parseClipboard(clipboard)}
          rowMoved={(): void => resort()}
          options={{
            height: '426px',
            rowContextMenu: disableEditing ? false : rightClickMenu,
            movableRows: !disableEditing,
          }}
        />
      </div>
    );
  }
}
